let cookie = {
  setCookie(cname,cvalue,exdays){
		var d = new Date();
		d.setTime(d.getTime()+(exdays*24*60*60*1000));
		var expires = "expires="+d.toGMTString();
		document.cookie = cname + "=" + cvalue + "; " + expires;
	},
	getCookie(cname){
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) 
		{
			var c = ca[i].trim();
			if (c.indexOf(name)==0) return c.substring(name.length,c.length);
		}
		return "";
	},
	removeCookie(cname){
		document.cookie = cname + "=null" +
		";expires=Thu, 01 Jan 1970 00:00:01 GMT";
	}
}
export default cookie ;


// WEBPACK FOOTER //
// ./src/util/cookie.js